const icons = {
  "you-tube": "61697",
  "world-cruise-collection": "61698",
  "wine-sailings": "61699",
  "wheelchair": "61700",
  "warning": "61701",
  "voyages": "61702",
  "venetian-society-saving": "61703",
  "user": "61704",
  "user-booking": "61705",
  "twitter": "61706",
  "training": "61707",
  "suites": "61708",
  "suite-upgrade-promo": "61709",
  "suite-upgrade-discount": "61710",
  "star": "61711",
  "special-price": "61712",
  "single-fares": "61713",
  "shore-excursions": "61714",
  "ship": "61715",
  "ship-lateral": "61716",
  "ship-lateral-stroke": "61717",
  "services": "61718",
  "secure-payment": "61719",
  "secure-payment-card": "61720",
  "search": "61721",
  "routes": "61722",
  "routes-2": "61723",
  "reduced-fares-in-business-class": "61724",
  "quito-by-night": "61725",
  "public-area": "61726",
  "promo": "61727",
  "privato": "61728",
  "private-flight-in-business-class": "61729",
  "pre-cruise": "61730",
  "post-cruise": "61731",
  "ports": "61732",
  "plus": "61733",
  "play": "61734",
  "placeholder": "61735",
  "pinterest": "61736",
  "pin": "61737",
  "phone": "61738",
  "pdf": "61739",
  "payment": "61740",
  "pack": "61741",
  "pack-denali": "61742",
  "p2p-prepaid-promo": "61743",
  "p2p-prepaid-discount": "61744",
  "open-tab": "61745",
  "new": "61746",
  "my-services": "61747",
  "minus": "61748",
  "meal-included": "61749",
  "logo": "61750",
  "limited": "61751",
  "limited-space-available": "61752",
  "instagram": "61753",
  "info": "61754",
  "hotel-charter": "61755",
  "gentlemen-host": "61756",
  "free-transfers": "61757",
  "free-hotel": "61758",
  "free-flight": "61759",
  "food-beverage": "61760",
  "flight": "61761",
  "flag": "61762",
  "filters": "61763",
  "facebook": "61764",
  "expand": "61765",
  "evening-excursions": "61766",
  "email": "61767",
  "early-booking-bonus": "61768",
  "duration_2-h": "61769",
  "duration": "61770",
  "duration-all-day": "61771",
  "duration-8-h": "61772",
  "duration-4-h": "61773",
  "download": "61774",
  "door-to-door": "61775",
  "discount-chip": "61776",
  "dining": "61777",
  "diamond": "61778",
  "days": "61779",
  "culinary-sailings": "61780",
  "countries": "61781",
  "connecting-suite": "61782",
  "compass": "61783",
  "communication": "61784",
  "close": "61785",
  "clock": "61786",
  "circle": "61787",
  "circle-question": "61788",
  "circle-phone": "61789",
  "circle-close": "61790",
  "circle-check": "61791",
  "chevron-up": "61792",
  "chevron-right": "61793",
  "chevron-left": "61794",
  "chevron-down": "61795",
  "check": "61796",
  "chat": "61797",
  "bullet": "61798",
  "brochure": "61799",
  "bridge-sailings": "61800",
  "bath-shower-separate": "61801",
  "bath-shower-combination": "61802",
  "arrow-up": "61803",
  "arrow-right": "61804",
  "arrow-left": "61805",
  "arrow-down": "61806",
  "antarctica-bridge": "61807",
  "anchor": "61808",
  "all-inclusive-offer": "61809",
  "alert": "61810",
  "alarm": "61811",
  "alarm-clock": "61812",
  "activity-level-full": "61813",
  "activity-level-empty": "61814",
  "accessibility": "61815",
  "3rd-guest-capacity": "61816"
};
export default icons;